module.exports = __webpack_public_path__ + "img/473.6a34d1d4.png";